import { HtmlExpression } from "./html-expression.interface";
import { HtmlExpressionType } from "./html-expression-type.enum";


export class HtmlText implements HtmlExpression {
    public readonly type: HtmlExpressionType;

    public readonly text: string;
    public readonly start: number;
    public readonly end: number;

    constructor(text: string, start: number, end: number) {
        this.type = HtmlExpressionType.Text;
        this.start = start;
        this.text = text;
        this.end = end;
    }
}